// @flow
export default (props) => {
  switch (props.decorator || props.is) {
    case 'EshopPhotogallery':
      // ESHOP: Produktova fotogalerie
      return import('fg-frontend/components/EshopPhotogallery');
    // case 'EshopModel3D':
    //   ESHOP: 3D model v ramci produktove fotogalerie (odeberte, pokud neni pozadovana funkcionalita 3D modelu (nastavitelne na fotogalerii))
      // return import('fg-frontend/components/EshopModel3D');
    case 'EshopImageMagnify':
      // ESHOP: Lupa v ramci produktove fotogalerie (odeberte, pokud neni pozadovana funkcionalita lupy (nastavitelne na fotogalerii))
      return import('fg-frontend/components/EshopImageMagnify');
    case 'EshopGalleryPopup':
      // ESHOP: Podpora galerie v popupu (odeberte, pokud neni pozadovano chovani galerie v popupu)
      return import('fg-frontend/components/EshopGalleryPopup');
    case 'EshopOrderForm':
      // ESHOP: Podpurna komponenta pro vlozeni zbozi do kosiku (odeberte, pokud nemate v projektu nakupni proces)
      return import('fg-frontend/components/EshopOrderForm');
    case 'ProductListSlider':
      // ESHOP: slider s produkty (odeberte, pokud neni v projektu zapnuta feature productProductRelation ani catalogRecentlyVisitedConfig v ramci catalogTracking feature)
      return import('fg-frontend/components/ProductListSlider');
    case 'BranchPicker':
      // ESHOP: Komponenta pro vyber pobocky v ramci vybranych doprav (odeberte, pokud neni na widgetu pro vyber dopravy nastavene metadato <enableBranchPicker>true</enableBranchPicker>)
      return import('fg-frontend/src/components/BranchPicker');
    case 'EshopVariantStockHandler':
    //   ESHOP: Komponenta pro osetreni vyberu variant v detailu produktu (odeberte, pokud neni na komponente nastaveno metadato <enableVariantStockHandler>true</enableVariantStockHandler>)
      return import('fg-frontend/src/components/EshopVariantStockHandler');
    case 'EshopFulltextAutocomplete':
      // ESHOP: Fulltextovy naseptavac (odeberte, pokud neni povolena fulltext feature)
      return import('fg-frontend/src/components/EshopFulltextAutocomplete');

  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureEshopComponents.js